<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title">
        Revenue Over Time
        <CalculationTooltip text="Shows revenue grouped by the selected granularity. The dashed line shows the comparison period." />
      </h3>
    </div>
    <div class="panel-body">
      <LineChart v-if="chartData" :key="chartKey" :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { Line as LineChart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Filler,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import CalculationTooltip from '../../scheduling-dashboard/components/CalculationTooltip.vue';

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, Filler, Title, Tooltip, Legend);

export default {
  name: 'RevenueTimeSeriesChart',
  components: { LineChart, CalculationTooltip },
  props: {
    timeSeries: { type: Array, required: true }
  },
  data: function() {
    return {
      chartKey: 0
    };
  },
  watch: {
    timeSeries: function() {
      this.chartKey++;
    }
  },
  computed: {
    chartData() {
      if (!this.timeSeries || this.timeSeries.length === 0) return null;
      var datasets = [
        {
          label: 'Revenue',
          data: this.timeSeries.map(function(d) { return d.revenue / 100; }),
          borderColor: '#337ab7',
          backgroundColor: 'rgba(51, 122, 183, 0.1)',
          fill: true,
          tension: 0.3
        }
      ];
      if (this.timeSeries[0].yoy_revenue != null) {
        datasets.push({
          label: 'Previous Period',
          data: this.timeSeries.map(function(d) { return d.yoy_revenue / 100; }),
          borderColor: '#999',
          borderDash: [5, 5],
          fill: false,
          tension: 0.3
        });
      }
      return {
        labels: this.timeSeries.map(function(d) { return d.period_label; }),
        datasets: datasets
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { position: 'top' },
          tooltip: {
            callbacks: {
              label: function(context) {
                var label = context.dataset.label || '';
                var value = context.parsed.y;
                return label + ': $' + value.toLocaleString();
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: function(value) {
                return '$' + value.toLocaleString();
              }
            }
          }
        }
      };
    }
  }
};
</script>
